<template>
  <div class="appconfig-nav
    d-none d-lg-block border-end border-300
    position-fixed overflow-auto top-0 bottom-0 start-0
  ">
    <nav>
      <ul>
        <!-- TODO: Fix hydration error w/o client only -->
        <client-only>
          <li v-for="item in navItems" :key="item.url">
            <NuxtLink :to="item.url">{{item.label}}</NuxtLink>
          </li>
        </client-only>
      </ul>
    </nav>
  </div>
</template>

<script>
import { useApplicationConfigStore } from '~/store/application-config'
import { storeToRefs } from 'pinia'

export default {
  name: 'AppConfigNav',
  setup() {
    const { navItems } = storeToRefs(useApplicationConfigStore())
    return {
      navItems
    }
  },
}
</script>

<style lang="scss" scoped>

.appconfig-nav {
  width: $sidenav-width;

  z-index: $zindex-fixed;
  background: $neutral-200;

  &.customized-affiliate {
    background: $app-aside-background-color;
  }
}

</style>
